import * as tslib_1 from "tslib";
import * as React from 'react';
import getWeatherImage from '../utils/getWeatherImage';
import store from '../store/store';
import strings from 'owa-strings/owa-common-strings';
import { format } from 'owa-strings';
import { reactive } from 'satcheljs/lib/legacy/react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
var styles = require('./UpNextExpansion.scss');
var classNames = require('classnames/bind');
var UpNextExpansion = /** @class */ (function (_super) {
    tslib_1.__extends(UpNextExpansion, _super);
    function UpNextExpansion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNextExpansion.prototype.render = function () {
        var _this = this;
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: styles.container, href: store.weatherClickThrough, target: "_blank" }, this.props.weatherDailyConditions.map(function (item, index) {
            if (index > 0) {
                // We do not care about the item at index 0 as it is the weather for
                // Now. From index 1 forward they will represent: today, tomorrow, etc.
                var precipitationChance = parseInt(item.PrecipitationChance);
                var weatherCharmClasses = classNames(!!precipitationChance && styles.withPrecipitation, getWeatherImage(item.SkyCode), getWeatherImage()); // Fallback css image.
                return (React.createElement("div", { className: styles.weather },
                    React.createElement("div", { className: styles.day }, _this.getDayShortName(index)),
                    React.createElement("div", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }, !!precipitationChance && (React.createElement("span", null,
                        React.createElement(Icon, { className: styles.drop, iconName: "Drop" /* Drop */ }),
                        format(strings.percentage, precipitationChance)))),
                    React.createElement("div", { className: styles.high },
                        format(strings.temperature, item.High),
                        React.createElement("span", { className: styles.low }, format(strings.temperature, item.Low)))));
            }
            else {
                return null;
            }
        }))));
    };
    UpNextExpansion.prototype.getDayShortName = function (index) {
        var dayIndex = (new Date().getDay() + (index - 1)) % 7;
        switch (dayIndex) {
            case 0:
                return strings.sundayShort;
            case 1:
                return strings.mondayShort;
            case 2:
                return strings.tuesdayShort;
            case 3:
                return strings.wednesdayShort;
            case 4:
                return strings.thursdayShort;
            case 5:
                return strings.fridayShort;
            case 6:
                return strings.saturdayShort;
        }
        // Unreachable point.
        return null;
    };
    UpNextExpansion = tslib_1.__decorate([
        reactive({
            weatherClickThrough: function () { return store.weatherClickThrough; },
            weatherDailyConditions: function () { return store.weatherDailyConditions; },
        })
    ], UpNextExpansion);
    return UpNextExpansion;
}(React.Component));
export default UpNextExpansion;
//# sourceMappingURL=UpNextExpansion.js.map